import React, { useEffect, useRef, useState } from 'react'
import '../assets/css/dispatch.css'
import SecondaryNavbar from './SecondaryNavbar'
import TYVNavbar from './TYVNavbar'
import filter from '../assets/images/filter.svg'
import SearchBox from './SearchBox'
import FooterButton from './FooterButton'
import VINHeader from './VINHeader'
import { DocumentModal, SuccessModal } from './DocumentUploadModal'
import * as XLSX from 'xlsx';

export default function Dispatch() {
    const [selectCount, setselectCount] = useState(0);
    const [dispatchDetail, setdispatchDetail] = useState([
        {
            "VINS": "TC - 12 45",
            "Last Seen At": "Parking Zone 1",
            "VIN Status": "CRTD",
            "Updated At": "24-08-2023 09:30",
        },
        {
            "VINS": "EV - 12 45",
            "Last Seen At": "Zone 2",
            "VIN Status": "ROLL",
            "Updated At": "28-08-2023 10:40",
        },
        {
            "VINS": "CC - 12 45",
            "Last Seen At": "Unknown",
            "VIN Status": "SFLT",
            "Updated At": "20-08-2023 09:50",
        },
        {
            "VINS": "BS - 12 45",
            "Last Seen At": "Parking Zone 2",
            "VIN Status": "WTC",
            "Updated At": "29-08-2023 05:30",
        },
        {
            "VINS": "TC - 12 45",
            "Last Seen At": "Parking Zone 3",
            "VIN Status": "CRTDO",
            "Updated At": "15-09-2023 11:20",
        },
        {
            "VINS": "TC - 12 45",
            "Last Seen At": "Unknown",
            "VIN Status": "SFLT",
            "Updated At": "30-07-2023 12:30",
        },
        {
            "VINS": "TC - 12 45",
            "Last Seen At": "Parking Zone 1",
            "VIN Status": "ROLL /",
            "Updated At": "15-06-2023 01:44",
        },
        {
            "VINS": "CC - 12 45",
            "Last Seen At": "Unknown",
            "VIN Status": "WTC",
            "Updated At": "17-05-2023 10:30",
        },
        {
            "VINS": "BS - 12 45",
            "Last Seen At": "Parking Zone 3",
            "VIN Status": "CRTD",
            "Updated At": "13-08-2023 11:50",
        },
        {
            "VINS": "EV - 12 45",
            "Last Seen At": "Parking Zone 2",
            "VIN Status": "ROLL /",
            "Updated At": "17-05-2023 03:30",
        },
    ])
    const [isModalOpen, setModalIsOpen] = useState(false);

    console.log(useState("hello")[1])
    const toggleModal = () => {
        setModalIsOpen(!isModalOpen);
    };

    function handleButton(value) {
        console.log("value = ", value)
        if(value==="download-bulk"){
            let ws = XLSX.utils.json_to_sheet(dispatchDetail);
            let wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "sheet");
            let buf = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' }); // generate a nodejs buffer
            let str = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' }); // generate a binary string in web browser
            XLSX.writeFile(wb, `myfilename.xlsx`);
        }
    }

    return (
        <>
            <TYVNavbar />
            <div className='dashboard-main'>
                <SecondaryNavbar />

                <div className='dispatch-container'>
                    <VINHeader />
                    <div className='dispatch-map-container'>
                        <div className='dispatch-map-inner'>
                            <div className='dispatch-map'></div>
                            <div className='dispatch-table-container'>
                                <div className='dispatch-table-heading'>
                                    {selectCount} Selected
                                    <SearchBox />
                                </div>
                                <table className='dispatch-table' cellPadding={15}>
                                    <thead>
                                        <tr>
                                            <th>VINs</th>
                                            <th>Last Seen At</th>
                                            <th>VIN Status</th>
                                            <th>Updated At <img src={filter} alt="search" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            dispatchDetail.map((data, index) => {
                                                return (
                                                    <tr key={`tr${index}`}>
                                                        <td><input type="checkbox" id={`vins${index}`} name="vins" /></td>
                                                        <td>{data['VINS']}</td>
                                                        <td>{data['Last Seen At']}</td>
                                                        <td>{data['Updated At']}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className='dispatch-footer'>
                            <div className='dispatch-footer-inner'>
                                <FooterButton value="download-bulk" color="#82C1A7" handle={handleButton} />
                                <div id="clear-filter" className='clear-filter' onClick={() => handleButton("clear-filter")}>Clear Filter</div>
                            </div>
                            <div className='dispatch-footer-inner'>
                                <FooterButton value="view-history" color="#A7A7A7" handle={handleButton} />
                                <FooterButton value="upload-bulk" color="#FFA222" handle={toggleModal} />
                                {isModalOpen && <DocumentModal onRequestClose={toggleModal} />}
                                {/* <button className="footer-button" style={{ backgroundColor: "#FFA222" }} onClick={() => { fileUpload() }}>Upload Bulk</button> */}
                                <FooterButton value="dispatch-vins" color="#82C1A7" handle={handleButton} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>
                {`  

                `}
            </style>
        </>
    )
}